import React from "react";

export default function DocumentFooter() {
    return (
        <div className="mt-6 text-xs opacity-70 flex items-center justify-between">
            <div>Documento generato da Norma HACCP</div>
            <div>{new Date().toLocaleDateString("it-IT")}</div>
        </div>
    );
}
